import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utiles/api';
import { CommonContext } from './CommonContext';
import { useLocation } from 'react-router-dom';

export const EventContext = createContext();

export function EventContextProvider({ children }) {
    const { handleLogout, user } = useContext(CommonContext);
    const location = useLocation();
    const [addModal, setAddModal] = useState(false);
    const [desListData, setDesListData] = useState([]);
    const [branchDropData, setBranchDropData] = useState([]);
    const [categoryDropData, setCategoryDropData] = useState([]);
    const [eventListData, setEventListData] = useState([]);
    const [galleryData, setGalleryData] = useState([]);
    const [announcementListData, setAnnouncementListData] = useState([]);
    const [advisoryListData, setAdvisoryListData] = useState([]);
    const [locationData, setLocationData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSorting, setIsSorting] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [content, setContent] = useState('')
    const [formTemp, setFormTemp] = useState({
        status: '1',
        is_front: 1,
    });
    const [listCount, setListCount] = useState(null);
    const [filters, setFilters] = useState({
        searchBy: 'name',
        searchValue: '',
        start_date: null,
        end_date: null,
        event_status: '',
        is_front: 1,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [isReset, setIsReset] = useState(false);
    const handleAddModals = () => {
        setAddModal(true);
        setIsEdit(false);
    };

    const handleCloseModal = () => {
        setAddModal(false);
        setIsEdit(false);
        setFormTemp({
            status: '1',
        });
    };

    const onDesLoadApi = async () => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('branch/desg/list');
            if (response.data.s === 1) {
                setDesListData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onCategoryDropApi = async () => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('category/dropdown', { parent_id: 1 });
            if (response.data.s === 1) {
                setCategoryDropData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onBranchDropApi = async () => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('branch/dropdown');
            if (response.data.s === 1) {
                setBranchDropData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onLoadApi = async (currentPage, itemsPerPage) => {
        setIsLoading(true);
        filters.branch_id = user?.branch_id;
        try {
            const response = await commonApi.post(`events/list?page=${currentPage}&per_page=${itemsPerPage}`, filters);
            if (response.data.s === 1) {
                setEventListData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onGalleryLoadApi = async (payload) => {
        let payloadFilters = { ...payload };
        payloadFilters.event_id = location?.state?.id
        setGalleryData([]);
        setIsLoading(true);
        // location?.state?.id
        try {
            const response = await commonApi.post('events/gallery/list', payloadFilters);
            if (response.data.s === 1) {
                if (payload?.is_active === 1) {
                    setIsSorting(true);
                } else {
                    setIsSorting(false);
                }
                setGalleryData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onAnnouncementLoadApi = async () => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('branch/announcement/list');
            if (response.data.s === 1) {
                setAnnouncementListData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onAdvisoryLoadApi = async () => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('branch/advisory/list');
            if (response.data.s === 1) {
                setAdvisoryListData(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch desListData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (location?.state) {
            setLocationData(location?.state);
        }
    }, [location]);
    useEffect(() => {
        onCategoryDropApi();
        onBranchDropApi();
        if (location?.state) {
            onGalleryLoadApi();
        }
    }, []);

    const contextValue = {
        isReset,
        setIsReset,
        listCount,
        setListCount,
        itemsPerPage,
        setItemsPerPage,
        currentPage,
        setCurrentPage,
        filters,
        setFilters,
        content,
        setContent,
        onAdvisoryLoadApi,
        advisoryListData,
        setAdvisoryListData,
        onAnnouncementLoadApi,
        announcementListData,
        setAnnouncementListData,
        branchDropData,
        setBranchDropData,
        locationData,
        setLocationData,
        onGalleryLoadApi,
        galleryData,
        setGalleryData,
        onCategoryDropApi,
        categoryDropData,
        onDesLoadApi,
        onLoadApi,
        eventListData,
        setEventListData,
        isEdit,
        setIsEdit,
        formTemp,
        setFormTemp,
        addModal,
        setAddModal,
        handleCloseModal,
        handleAddModals,
        desListData,
        setDesListData,
        isSorting,
        isLoading,
        setIsLoading,
        setIsSorting,
        onDesLoadApi
    };

    return <EventContext.Provider value={contextValue}>{children}</EventContext.Provider>;
}
